'use client';

import type { ReactNode } from 'react';
import { Suspense } from 'react';
import { WorkspacesHeader } from '@frameio/app-header/components/WorkspacesHeader';
import { Box } from '@frameio/vapor';
import { AccountSelectionButton } from './_components/AccountSelectionButton';
import { HeaderHomeButton } from './_components/HeaderHomeButton';

export default function StaticHeaderLayout({
  breadcrumbs,
  actions,
}: {
  breadcrumbs: ReactNode;
  actions: ReactNode;
}) {
  return (
    <Suspense fallback={null}>
      <WorkspacesHeader>
        <HeaderHomeButton />
        <AccountSelectionButton />
        {breadcrumbs}
        <Box display="flex" gap={8} justifyContent="flex-end" paddingLeft={8}>
          {actions}
        </Box>
      </WorkspacesHeader>
    </Suspense>
  );
}
